export const NAME = 'clientSearch';

export const allowedSearchCombination = [
	['businessIn'],
	['personIn'],
	// todo - delete after all taskCreatingPages will be refactored to MUI
	['birthNumber'],
	['businessName', 'zipCode'],
	['businessName', 'street'],
	['businessName', 'municipality'],
	['businessName', 'birthDate'],
	['surname', 'firstName', 'zipCode'],
	['surname', 'firstName', 'street'],
	['surname', 'firstName', 'municipality'],
	['surname', 'firstName', 'birthDate'],
];

export const PARAMS_WITH_ADDED_ASTERISK = ['surname', 'firstName', 'businessName'];

export const dialogs = {
	requiredFields: `${NAME}/requiredFields`,
	invalidPersonIn: `${NAME}/invalidPersonIn`,
	invalidPersonInNotMatchingGivenBirthDate: `${NAME}/invalidPersonInNotMatchingGivenBirthDate`,
};

export const searchErrorMsgs = {
	invalidPersonInBeforeYear1954: 'RČ má 9 číslic a rok narození > 1954',
	invalidPersonInModulo: 'Rodné číslo, chyba v kontrolním součtu modulo',
	invalidPersonInNotMatchingGivenBirthDate: 'Datumová část rodného čísla nesouhlasí s uvedeným datem narození',
};
